import styled from "styled-components";
import { Heading, Logo, ButtonSettings, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const PromotionalPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: absolute;
  padding: ${props => props.theme.baseLayoutPaddingBs * 2}% ${props => props.theme.baseLayoutPaddingBs}%;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    background-color: #000;
    opacity: 0.3;
  }
`;

export const HeadingStyled = styled(Heading)`
  width: 80%;
  margin-bottom: ${props => props.theme.spacing.medium};
`;

export const TextStyled = styled(Text)`
  width: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "74%" : "80%")};
  font-weight: 100;
  ${props =>
    props.showBullet &&
    `
    display: list-item;
    list-style-position: inside;
  `}
`;

export const TextDisclaimerStyled = styled(Text)`
  position: absolute;
  font-weight: 100;
  padding-bottom: inherit;
  bottom: 0;
`;
export const PromotionalContainerStyled = styled.article`
  width: 80%;
  height: 100%;
  position: absolute;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 0;
  top: 0;
  padding: 5%;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "padding-right: 8%" : " padding-left: 8%")};
  ${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT && "padding-right: 1%")};
  
  ${/* background: ${props =>
    `linear-gradient(to ${
      props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"
    }, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0) 100%);`}; */ ""};
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  width: 22.625rem;
  display: block;
  text-transform: uppercase;
  ${props =>
    props.displayBlock
      ? `display: block`
      : `
      ${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "margin-right" : "margin-left"}: ${
          props.theme.spacing.small
        };
  `}
  margin-top: ${props => props.theme.spacing.xsmall};
  &:first-of-type {
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "margin-right" : "margin-left")}: 0;
    margin-top: ${props => props.theme.spacing.large};
  }
  &:last-of-type {
    margin-bottom: ${props => props.theme.spacing.small};
    margin-left: 0;
    margin-right:0;
  }
`;

export const LogoContainerStyled = styled.div`
  margin-bottom: ${props => props.theme.spacing.xlarge};
  margin-bottom: 0;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "padding-right" : "padding-left")}: 3.33vw;
`;

export const LogoWrapper = styled.div`
  display:flex;
  align-items:center;
`;

export const LogoStyled = styled(Logo)`
  display: block;
  ${props => props.inlineBlock && `display: inline-block`}
`;

export const SecondaryLogoStyled = styled.img`
  ${props => props.inlineBlock && `display: inline-block`}
  vertical-align: middle;
  margin-top: -25px;
  & + & {
    margin: 0 15px;
  }
`;
